import { render, staticRenderFns } from "./MetricItem.vue?vue&type=template&id=53f28f7a&scoped=true&"
import script from "./MetricItem.vue?vue&type=script&lang=js&"
export * from "./MetricItem.vue?vue&type=script&lang=js&"
import style0 from "./MetricItem.vue?vue&type=style&index=0&id=53f28f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f28f7a",
  null
  
)

export default component.exports